import React from 'react';

const StartTripModal = ({ destinations, onStart, onClose }) => (
  <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center p-4 z-[100]">
    <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md">
      <h3 className="text-2xl font-bold text-slate-900 mb-4">Iniciar Recorrido</h3>

      <p className="text-slate-600 mb-6">
        Selecciona tu primer destino para comenzar el viaje.
      </p>

      <div className="space-y-2 max-h-64 overflow-y-auto">
        {(destinations || []).map((dest) => (
          <button
            key={dest.id}
            onClick={() => onStart(dest)}
            className="w-full text-left p-3 rounded-md bg-slate-100 hover:bg-blue-100 transition-colors font-semibold text-slate-800"
          >
            #{dest.order + 1}: {dest.name}
          </button>
        ))}
      </div>

      <button
        onClick={onClose}
        className="mt-6 w-full bg-slate-200 text-slate-800 py-2 px-4 rounded-md hover:bg-slate-300"
      >
        Cancelar
      </button>
    </div>
  </div>
);

export default StartTripModal;